import { useQuery } from '@tanstack/react-query';
import { api, ApiError } from './api';
import type { WebMe } from './types';

export const meKey = ['me'] as const;

/** Angemeldeter Nutzer; `null` = nicht angemeldet (401). Andere Fehler werden weitergereicht. */
export function useMe() {
  return useQuery({
    queryKey: meKey,
    queryFn: async () => {
      try {
        return await api.get<WebMe>('/web/me');
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 30_000,
  });
}

/** Welche Browser-Logins der Server anbietet (Discord bzw. Microsoft nur, wenn eingerichtet). */
export function useAuthOptions() {
  return useQuery({
    queryKey: ['auth-options'],
    queryFn: () => api.get<{ discord: boolean; microsoft: boolean }>('/web/auth/options'),
    staleTime: Infinity,
  });
}

/** „Mit Microsoft anmelden“ (architecture.md 4.8), nur bestehende Konten. */
export function microsoftLoginUrl(returnTo = window.location.pathname + window.location.search) {
  return `/api/web/auth/microsoft/login?${new URLSearchParams({ returnTo })}`;
}

/** Discord-Login für Admins; `link` verknüpft Discord mit dem angemeldeten Konto (architecture.md 4.3). */
export function discordLoginUrl(returnTo = window.location.pathname + window.location.search, link = false) {
  const q = new URLSearchParams({ returnTo });
  if (link) q.set('link', 'true');
  return `/api/web/auth/discord/login?${q}`;
}
